import { render, staticRenderFns } from "./CommunicationFilters.vue?vue&type=template&id=30530ba2&scoped=true&"
import script from "./CommunicationFilters.vue?vue&type=script&lang=js&"
export * from "./CommunicationFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30530ba2",
  null
  
)

export default component.exports